import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export const PageHeader = ({ crumbs = [], title, subtitle, actions }) => (
  <div className="flex flex-wrap items-end justify-between gap-3 mb-4">
    <div className="min-w-0">
      {crumbs.length > 0 && (
        <nav data-testid="breadcrumbs" className="flex items-center gap-1 text-[11px] text-muted-foreground mb-1">
          {crumbs.map((c, i) => (
            <span key={i} className="flex items-center gap-1">
              {i > 0 && <ChevronRight className="h-3 w-3" />}
              {c.to ? <Link to={c.to} className="hover:text-foreground">{c.label}</Link> : <span>{c.label}</span>}
            </span>
          ))}
        </nav>
      )}
      <h1 data-testid="page-title" className="text-lg font-bold tracking-tight leading-tight">{title}</h1>
      {subtitle && <p className="text-xs text-muted-foreground mt-0.5">{subtitle}</p>}
    </div>
    {actions && <div className="flex items-center gap-2 flex-wrap">{actions}</div>}
  </div>
);
